import React from 'react';
import PropTypes from 'prop-types';
import { useAlert } from '../ui/Alert';
import MainPage from './MainPage';
import config from '../constants';
import { NotAutorized } from './NotAutorized';

const UpdatePage = ({
	children,
	show_error = false,
	loading,
	fail,
	message = '',
	headers = {},
}) => {
	const { push } = useAlert();

	if (show_error) {
		push({
			error: true,
			message: config.app.error,
		});
	}

	return (
		<MainPage headers={headers}>
			{loading ? (
				<div class="d-flex align-items-center justify-content-center">
					<div class="spinner-grow" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</div>
			) : fail ? (
				<NotAutorized message={message} />
			) : (
				children
			)}
		</MainPage>
	);
};

UpdatePage.propTypes = {
	children: PropTypes.node,
	show_error: PropTypes.bool,
	loading: PropTypes.bool,
	fail: PropTypes.bool,
	message: PropTypes.string,
	headers: PropTypes.shape({
		icon: PropTypes.string,
		title: PropTypes.string,
		description: PropTypes.string,
		breadcrumbs: PropTypes.arrayOf(
			PropTypes.shape({
				link: PropTypes.string,
				title: PropTypes.string.isRequired,
			})
		),
	}),
};

UpdatePage.defaultProps = {
	show_error: false,
	loading: true,
	fail: false,
	headers: {},
	message: '',
};

export default UpdatePage;
